<template>
    <div class="app-footer copyright">
        <a href="https://www.dxrj.cn/" target="_blank">Copyright © 2016-{{year}} 陕西大虾软件科技有限公司 &ensp;版权所有</a>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                year:''
            }
        },
        mounted(){
            this.year = new Date().getFullYear();
        }
    }
</script>
<style lang="less">
    .app-footer {
        margin: auto;
        text-align: center;
        padding: 10px 0 30px;
        /*float: bottom;*/
        color: rgba(0,0,0,.45);
        a {
            color: rgba(0,0,0,.8);
            /*color: #fff;*/
            font-size: 16px;
        }
    }
</style>
